module.exports = __webpack_public_path__ + "img/20210430_111533.b37bad5f.jpg";